import UserRole from 'common/enums/UserRole';

export default{

    computed: {

        isAdmin() {

            return this.$acl.is(UserRole.ADMIN);
        }
    }
};
